import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import { BootstrapVue, IconsPlugin } from "bootstrap-vue"
import VueAwesomeSwiper from "vue-awesome-swiper"
import Vuelidate from "vuelidate"
import "swiper/css/swiper.css"
import "./assets/styles/style.scss"

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(Vuelidate)

new Vue({
  router,
  render: function(h) {
    return h(App)
  },
}).$mount("#app")
